// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { L10n } from '@syncfusion/ej2-base';
import { BehaviorSubject } from 'rxjs';
import syncfusionEn from './syncfusion/en.json';
import syncfusionEs from './syncfusion/es.json';

export interface Locale {
  lang: string;
  data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';
const SYNCFUSION_LOCALES: { [lang: string]: object } = {
  es: (syncfusionEs as any)['es'],
  en: (syncfusionEn as any)['en-US'],
};

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];

  private changeLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('')
  changeLanguage$ = this.changeLanguage.asObservable();

  constructor(
    private translate: TranslateService,
  ) {
    // add new langIds to the list
    this.translate.addLangs(['es','en','pt-BR']);

    // this language will be used as a fallback when a translation isn't found in the current language

    var ln = navigator.language;
    if(ln.startsWith("es")){
      this.translate.setDefaultLang('es');
    }else if(ln.startsWith("en")){
      this.translate.setDefaultLang('en');
    }else if(ln.startsWith("pt")){
      this.translate.setDefaultLang('pt-BR');
    }else this.translate.setDefaultLang('es');

    L10n.load(SYNCFUSION_LOCALES);
  }

  getSyncfusionCulture(): string {
    const lang = this.translate.currentLang || this.translate.getDefaultLang();
    return SYNCFUSION_LOCALES[lang] ? lang : 'en';
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.setLanguage(this.getSelectedLanguage());
  }

  setLanguage(lang: string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
      this.changeLanguage.next(lang);
    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) ||
      this.translate.getDefaultLang()
    );
  }
}
